type TableFilter = { id: string | number; value: any };
type TableFetchParams = Pick<TableState, 'filters' | 'sortBy' | 'pageIndex' | 'pageSize'>;
export type TableSort = { id: string; desc: boolean };
interface TableState {
  pageIndex: number;
  pageSize: number;
  sortBy: TableSort[];
  filters: TableFilter[];
  hiddenColumns: string[];
  selectedRowIds: Record<number | string, boolean>;
  data: any[];
  total: number;
  loading: boolean;
  error: string | null;
  meta: Record<string, any>;
  globalFilter: string;
}

export const tableQueryMaker = (params: TableFetchParams) => {
  const filters = params.filters.reduce((acc, { id, value }) => ({ ...acc, [id]: value }), {});
  const sort = params.sortBy.reduce((acc, { id, desc }) => ({ ...acc, sort_column: id, sort_order: desc ? 'desc' : 'asc' }), {});
  const page = params.pageIndex + 1;

  return { ...filters, ...sort, page, per_page: params.pageSize };
};

export const tableFilterQueryMaker = (filters: TableFilter[]) => {
  return filters.reduce((acc, { id, value }) => ({ ...acc, [id]: value }), {});
};
